/**
 * Resume facts for the hh-like candidate card (доработка №4/№14, Чат 1). [Claude] 2026-11-03
 * Work places come from hh at import as text blocks in other_work_expirience:
 * "Должность: …\nКомпания: …\nОтрасль: …\nРегион: …\nПериод: 2022-10-01 — н.в.\nОписание: …"
 */
const FIELDS = {
    "Должность": "position",
    "Компания": "company",
    "Отрасль": "industry",
    "Регион": "region",
    "Период": "period",
    "Описание": "description",
};

const MONTHS = ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"];

function parseDate(value) {
    const m = String(value || "").match(/(\d{4})-(\d{2})/);
    return m ? { y: Number(m[1]), m: Number(m[2]) } : null;
}

export function parseWorkPlace(text) {
    const out = { position: "", company: "", industry: "", region: "", start: null, end: null, current: false, description: "" };
    let field = null;
    for (const line of String(text || "").split("\n")) {
        const m = line.match(/^(Должность|Компания|Отрасль|Регион|Период|Описание):\s?(.*)$/);
        if (m) {
            field = FIELDS[m[1]];
            if (field === "period") {
                const [from, to] = m[2].split("—").map((s) => s.trim());
                out.start = parseDate(from);
                out.current = !to || /н\.в\./.test(to);
                out.end = out.current ? null : parseDate(to);
                field = null;
            } else {
                out[field] = m[2].trim();
            }
        } else if (field === "description") {
            out.description += `\n${line}`;
        }
    }
    out.description = out.description.trim();
    return out;
}

export function parseWorkHistory(list) {
    return (Array.isArray(list) ? list : []).map(parseWorkPlace).filter((p) => p.position || p.company);
}

export function placeMonths(place, today = new Date()) {
    if (!place?.start) return 0;
    const end = place.end || { y: today.getFullYear(), m: today.getMonth() + 1 };
    return Math.max(0, (end.y - place.start.y) * 12 + (end.m - place.start.m) + 1);
}

/** Total experience in months; overlapping jobs are counted once. */
export function totalMonths(places, today = new Date()) {
    const covered = new Set();
    for (const place of places || []) {
        if (!place?.start) continue;
        const end = place.end || { y: today.getFullYear(), m: today.getMonth() + 1 };
        const from = place.start.y * 12 + place.start.m;
        const to = Math.min(end.y * 12 + end.m, from + 1200);
        for (let idx = from; idx <= to; idx += 1) covered.add(idx);
    }
    return covered.size;
}

const plural = (n, one, few, many) => {
    const a = n % 10;
    const b = n % 100;
    if (a === 1 && b !== 11) return one;
    if (a >= 2 && a <= 4 && (b < 12 || b > 14)) return few;
    return many;
};

export function formatMonths(months) {
    const n = Math.max(0, Math.round(Number(months) || 0));
    if (!n) return "";
    const years = Math.floor(n / 12);
    const rest = n % 12;
    return [
        years ? `${years} ${plural(years, "год", "года", "лет")}` : "",
        rest ? `${rest} ${plural(rest, "месяц", "месяца", "месяцев")}` : "",
    ].filter(Boolean).join(" ");
}

export function formatPeriod(place) {
    if (!place?.start) return "";
    const from = `${MONTHS[place.start.m - 1]} ${place.start.y}`;
    const to = place.current || !place.end ? "по настоящее время" : `${MONTHS[place.end.m - 1]} ${place.end.y}`;
    return `${from.charAt(0).toUpperCase()}${from.slice(1)} — ${to}`;
}

/** «Ждёт ответа 4 часа» for responses nobody has handled yet. */
export function waitingText(appliedAt, now = new Date()) {
    const t = appliedAt ? new Date(appliedAt).getTime() : NaN;
    if (!Number.isFinite(t)) return "";
    const hours = Math.floor((now.getTime() - t) / 3600000);
    if (hours < 0) return "";
    if (hours < 1) return "Ждёт ответа меньше часа";
    if (hours < 48) return `Ждёт ответа ${hours} ${plural(hours, "час", "часа", "часов")}`;
    const days = Math.floor(hours / 24);
    return `Ждёт ответа ${days} ${plural(days, "день", "дня", "дней")}`;
}

export function appliedText(appliedAt, vacancy) {
    const d = appliedAt ? new Date(appliedAt) : null;
    if (!d || Number.isNaN(d.getTime())) return vacancy ? `Вакансия: ${vacancy}` : "";
    const day = d.toLocaleDateString("ru-RU", { day: "numeric", month: "long" });
    return vacancy ? `Откликнулся ${day} на ${vacancy}` : `Откликнулся ${day}`;
}
